"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permission = exports.PermissionSectionType = exports.PermissionGroupType = void 0;
var PermissionGroupType;
(function (PermissionGroupType) {
    PermissionGroupType[PermissionGroupType["Outlet"] = 0] = "Outlet";
    PermissionGroupType[PermissionGroupType["Tenant"] = 1] = "Tenant";
})(PermissionGroupType = exports.PermissionGroupType || (exports.PermissionGroupType = {}));
var PermissionSectionType;
(function (PermissionSectionType) {
    PermissionSectionType[PermissionSectionType["OutletAdmin"] = 0] = "OutletAdmin";
    PermissionSectionType[PermissionSectionType["TenantAdmin"] = 1] = "TenantAdmin";
    PermissionSectionType[PermissionSectionType["POS"] = 2] = "POS";
    PermissionSectionType[PermissionSectionType["OrderManager"] = 3] = "OrderManager";
    PermissionSectionType[PermissionSectionType["Express"] = 4] = "Express";
    PermissionSectionType[PermissionSectionType["KDS"] = 5] = "KDS";
})(PermissionSectionType = exports.PermissionSectionType || (exports.PermissionSectionType = {}));
exports.Permission = {
    tables: {
        id: '09a2ba81-36f5-483e-820d-5f86288f5d8a',
        name: 'tables',
    },
    manageOutletProducts: {
        id: '702b875c-0dc9-45b9-9bea-8173c6e73a01',
        name: 'manageoutletproducts',
    },
    manageStocks: {
        id: '1b2795ef-ded5-4a31-9d8a-f479cc84f2cc',
        name: 'managestocks',
    },
    manageIntegration: {
        id: '26d0d310-32b5-4445-b89e-6a75d1c8cd7c',
        name: 'manageintegration',
    },
    createCompany: {
        id: '588e4c6d-e774-47c8-8aa5-912d60db864a',
        name: 'createcompany',
    },
    editCompany: {
        id: '5c1d29f6-7879-4f7d-a112-4fb5aecd2c64',
        name: 'editcompany',
    },
    deleteCompany: {
        id: '30a03e07-15da-495c-aa24-80007f99675f',
        name: 'deletecompany',
    },
    manageUpsellGroups: {
        id: '1938deb3-858d-47ad-b33b-4fc68928d09b',
        name: 'manageupsellgroups',
    },
    manageCompanyMember: {
        id: 'b10990ac-175a-44ad-9ed8-0d71e98ee861',
        name: 'managecompanymember',
    },
    manageAdvancePricing: {
        id: '31490069-3895-40fb-a894-06485597d671',
        name: 'manageadvancepricing',
    },
    manageAccounting: {
        id: '4f1fbcb3-9989-4e10-9f7a-d01904c7e884',
        name: 'manageaccounting',
    },
    managePreOrders: {
        id: 'cc102589-bfff-41b2-9895-ced87bc1e589',
        name: 'managepreorders',
    },
    viewAnalytics: {
        id: '69875206-d89d-486d-b6e2-e869b98abec6',
        name: 'viewanalytics',
    },
    manageCourses: {
        id: '8d0ce026-aa21-411e-a5f7-0d6ff1d0ac18',
        name: 'managecourses',
    },
    createProducts: {
        id: '9236e702-91c4-4233-b4e8-ea442888b7e5',
        name: 'createproducts',
    },
    manageIngredients: {
        id: '9418a8d4-b23e-41a3-8723-e7553030d718',
        name: 'manageingredients',
    },
    manageAddonGroups: {
        id: 'a2086df3-44bc-45f0-8114-3ca37de2bc00',
        name: 'manageaddongroups',
    },
    managePermissionGroups: {
        id: 'b7bfbd4d-15ba-4ed7-90a8-d4a05a2a1d10',
        name: 'managepermissiongroups',
    },
    manageTicketDestinations: {
        id: 'bd036b19-4953-4f73-9f05-13c14df05f5c',
        name: 'manageticketdestinations',
    },
    manageEmployees: {
        id: 'eca6878a-e896-4b1f-a0fe-20ee11737644',
        name: 'manageemployees',
    },
    manageLicenses: {
        id: '576db927-ffe4-4c6a-bf13-afac30af3ce6',
        name: 'licenses',
    },
    editDeleteProducts: {
        id: 'ee1c5e66-5693-424b-9916-d5b98ea0f87d',
        name: 'editdeleteproducts',
    },
    manageDiscounts: {
        id: 'f79ff1fa-c1d9-492c-9f4c-4f45b759066a',
        name: 'managediscounts',
    },
    manageMenuGroups: {
        id: 'fa113415-3bee-4275-a7af-bc7011b50495',
        name: 'managemenugroups',
    },
    deleteCheck: {
        id: 'd1667759-dcef-4493-a93d-e09bf1ec181c',
        name: 'deletecheck',
    },
    deleteCheckItem: {
        id: '6392dbd8-acc7-4c3c-ac3c-4900d159573a',
        name: 'deletecheckitem',
    },
    printReceiptCopy: {
        id: 'b963d00e-474f-43a0-85af-da795de9b6eb',
        name: 'printreceiptcopy',
    },
    moveCheckToDifferentTable: {
        id: 'f45de32b-0290-4115-9b44-f0e14afcee95',
        name: 'movechecktodifferenttable',
    },
    rePurchase: {
        id: 'c93578b8-00cb-4dfd-ae46-cda3ac3387bc',
        name: 'repurchase',
    },
    refundOrder: {
        id: '54c6152e-8eca-405b-ad39-055614b808ee',
        name: 'refundorder',
    },
    changePriceOnCheckRow: {
        id: '1469bae8-0a7e-4512-b00c-4956c30f5f8f',
        name: 'changepriceoncheckrow',
    },
    addDiscountInPercent: {
        id: '0e8bda37-2d0c-49c4-800a-0b9143654d73',
        name: 'adddiscountinpercent',
    },
    giveOpenPrice: {
        id: '627ce70a-98b2-44dc-ae82-5bb95bae529e',
        name: 'giveopenprice',
    },
    reduceOrRemoveBongedCheckItems: {
        id: '01d09a93-af8d-4881-9c45-ec5232b13990',
        name: 'ReduceOrRemoveBongedCheckRows',
    },
    splitCheck: {
        id: 'b90d6315-aa42-481e-a0c4-6ad6be86c886',
        name: 'splitcheck',
    },
    /** @deprecated use splitPreviewPrintCheck instead */
    splitpreviewprintcheck: {
        id: '22c17040-62cc-4fdd-9c87-02e3f4c61037',
        name: 'splitpreviewprintcheck',
    },
    splitPreviewPrintCheck: {
        id: '22c17040-62cc-4fdd-9c87-02e3f4c61037',
        name: 'splitpreviewprintcheck',
    },
    previewPrintCheck: {
        id: '1013aaa4-a135-4454-887f-fef8f48c595b',
        name: 'previewprintcheck',
    },
    /** @deprecated use openCashDrawer instead */
    openCashBox: {
        id: 'a6bad71b-8cd1-499d-8b82-fe4fc916e592',
        name: 'opencashdrawer',
    },
    openCashBoxWithoutCashPayment: {
        id: 'd49700c7-b0bd-4029-ad5d-d92e40891b0e',
        name: 'opencashboxwithoutcashpayment',
    },
    /** @deprecated use posAdmin instead */
    posHardwareAdmin: {
        id: '540bd5f5-fbf2-46a5-8f64-301dc1061a25',
        name: 'posadmin',
    },
    posAdmin: {
        id: '540bd5f5-fbf2-46a5-8f64-301dc1061a25',
        name: 'posadmin',
    },
    posSettings: {
        id: 'a64cac91-3dc0-443d-9e4a-0e61738366cf',
        name: 'possettings',
    },
    deleteTicketedCheckItem: {
        id: 'c7857f82-d8da-429a-9a9a-49936cf18e57',
        name: 'deleteticketedcheckitem',
    },
    deletePrePrintedCheckItem: {
        id: '"b91f653c-c22a-435d-aab8-749db3652684',
        name: 'deletepreprintedcheckitem',
    },
    deleteTicketedCheck: {
        id: 'b642c5cb-c248-4074-b790-0578172d0419',
        name: 'deleteticketedcheck',
    },
    deletePrePrintedCheck: {
        id: '8794000d-7528-4a8a-afc5-fee5e6f7d7f0',
        name: 'deletepreprintedcheck',
    },
    /** @deprecated use posSettings instead */
    navigatePosSettings: {
        id: 'a64cac91-3dc0-443d-9e4a-0e61738366cf',
        name: 'possettings',
    },
    /** @deprecated use getVoucherBasis instead */
    navigateReportPage: {
        id: 'a99943e1-6171-4b65-ad98-30247c30a793',
        name: 'getvoucherbasis',
    },
    /** @deprecated use publishVoucherBasis instead */
    publishZReport: {
        id: '2eba5e77-617d-4179-8d9a-bacd2881cc35',
        name: 'publishvoucherbasis',
    },
    posManageProduct: {
        id: 'b855976f-f3b3-4933-8035-9127214f0a92',
        name: 'posmanageproduct',
    },
    posManageStocks: {
        id: '3006dc0d-7e2e-481a-af8a-93b562dd3e09',
        name: 'posmanagestocks',
    },
    /** @deprecated use addTipsOnOrder instead */
    addTip: {
        id: '1fd2893f-67ee-4de4-8839-b8dd5f5c226f',
        name: 'addtipsonorder',
    },
    posCreateCompany: {
        id: 'b4b68f2b-e7b8-4e8d-a732-f170a6982e00',
        name: 'poscreatecompany',
    },
    posEditCompany: {
        id: 'a2bb4b13-064e-446b-890d-3a678e704c2a',
        name: 'poseditcompany',
    },
    posManageCompanyMember: {
        id: 'c67bd2b9-113a-4730-8f10-daa2d58570ab',
        name: 'posmanagecompanymember',
    },
    posManageGiftCards: {
        id: '6636d550-8750-48bb-8f2c-ada95dd40ac2',
        name: 'posmanagegiftcards',
    },
    posManageCashInOut: {
        id: '83c14f32-dfde-4d51-9562-8999fe07e365',
        name: 'posmanagecashinout',
    },
    addCustomDiscount: {
        id: 'd35b7b24-4f98-11ed-a483-38f3ab48381a',
        name: 'addcustomdiscount',
    },
    posManageOtherOwnerCheck: {
        id: '2101acea-f262-499c-84b1-b811accc7523',
        name: 'posmanageotherownercheck',
    },
    posChangeCheckOwner: {
        id: '6d28f152-1dd1-43d3-af15-f62670281fc8',
        name: 'poschangecheckowner',
    },
    kdsAdmin: {
        id: '7220ed1c-9fc5-4cee-ac70-1e9eca444dc8',
        name: 'kdsadmin',
    },
    kdsSettings: {
        id: '47c4ca00-cd20-404a-8906-95cb2977d050',
        name: 'kdssettings',
    },
    posManagePrepaidWallets: {
        id: 'b6732e84-24e9-483c-ad1b-5ed911913ff0',
        name: 'posmanageprepaidwallets',
    },
    manageCompanyApproval: {
        id: '82ec7f15-81b7-4fb4-8113-3365d7a4c511',
        name: 'managecompanyapproval',
    },
    moveAdyenTerminals: {
        id: '15711ae0-6469-4186-8f7f-7ce101eeef26',
        name: 'moveadyenterminals',
    },
    getVoucherBasis: {
        id: 'a99943e1-6171-4b65-ad98-30247c30a793',
        name: 'getvoucherbasis',
    },
    publishVoucherBasis: {
        id: '2eba5e77-617d-4179-8d9a-bacd2881cc35',
        name: 'publishvoucherbasis',
    },
    openCashDrawer: {
        id: 'a6bad71b-8cd1-499d-8b82-fe4fc916e592',
        name: 'opencashdrawer',
    },
    addTipsOnOrder: {
        id: '1fd2893f-67ee-4de4-8839-b8dd5f5c226f',
        name: 'addtipsonorder',
    },
    expressAdmin: {
        id: '4aeae29a-2668-4c61-8f91-33009268380f',
        name: 'expressadmin',
    },
    expressSettings: {
        id: 'fd76dc53-1360-4bba-b8b7-a0140be10f88',
        name: 'expresssettings',
    },
};
